import React from "react";
import { FaHeadset, FaClipboardList, FaPlane, FaCoins } from "react-icons/fa";

const services = [
  {
    icon: <FaHeadset />,
    title: "Patient Support",
    img: "/assets/imgs/blog-3/Patientsupport.png",
    description:
      "24/7 multilingual support and advocacy throughout your medical journey",
    points: [
      "Multilingual patient advocacy",
      "24/7 emergency hotline",
      "Cultural orientation services",
      "Post-treatment follow-up",
      "Insurance claim assistance",
      "Family support & accommodation assistance",
      "Emergency response and crisis management",
      "Patient feedback & quality care",
    ],
  },
  {
    icon: <FaClipboardList />,
    title: "Treatment Planning",
    img: "/assets/imgs/blog-3/Patient-tritment-plan.png",
    description:
      "Comprehensive medical treatment coordination and care pathway design",
    points: [
      "Pre-treatment evaluations",
      "Personalized treatment plans",
      "Diagnostic imaging & lab coordination",
      "Post-operative & rehabilitation programs",
      "Multi-disciplinary care coordination",
      "Surgery & medication management",
      "Recovery timeline management",
      "Telemedicine follow-up & remote monitoring",
    ],
  },
  {
    icon: <FaPlane />,
    title: "Travel Coordination",
    img: "/assets/imgs/blog-3/Patient-travel-plan.png",
    description:
      "End-to-end travel arrangements and logistics management for medical tourists",
    points: [
      "Medical travel documentation",
      "Visa assistance & documentation",
      "Flight booking & accommodation",
      "Airport transfers & transportation",
      "Local guide services",
      "Emergency travel support",
      "Currency exchange and financial planning",
      "Real-time travel monitoring",
    ],
  },
  {
    icon: <FaCoins />,
    title: "Transparent Procedure Costing",
    img: "/assets/imgs/blog-3/Transparent-Procedure-Costing.png",
    description:
      "Detailed breakdown of fees for medical tourists with complete transparency",
    points: [
      "Consultation fees",
      "Hospital care fees",
      "Diagnosis fees",
      "Medication costs",
      "Examination fees",
      "Surgery fees",
      "Medical equipment fees",
      "Other associated costs",
    ],
  },
];

const ServiceCards = () => {
  return (
    <>
      <h3 className="">
        How SQUARE MEDTECH Can Support in Medical Tourism Services?
      </h3>
      <div className="py-5 bg-light">
        <div className="container">
          <div className="row g-4">
            {services.map((service, index) => (
              <div key={index} className="col-12 col-md-6 py-4">
                <div className="bg-white rounded-4 shadow-sm p-4 h-100">
                  <a class="blog-3__item-media d-block py-2">
                    <img
                      class="img-fluid "
                      src={service.img}
                      alt="icon not found"
                    />
                  </a>
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center mb-3"
                    style={{
                      width: "50px",
                      height: "50px",
                      background: "#f2f7fd",
                      color: "blue",

                      fontSize: "1.5rem",
                    }}
                  >
                    {service.icon}
                  </div>
                  <h5 className="fw-bold">{service.title}</h5>
                  <p className="text-muted small">{service.description}</p>
                  <ul className="mb-0 ps-3">
                    {service.points.map((point, i) => (
                      <li
                        key={i}
                        className="text-black mb-1"
                        style={{ fontWeight: 500, display: "flex", alignItems: "left", color: "#276CF5" }}
                      >
                        <img
                          src="./RightTicks.svg"
                          alt="tick"
                          style={{ width: "16px", height: "16px" }}
                        />{" "}
                        {point}
                        {/* <span>{point}</span> */}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceCards;
